export default "__VITE_ASSET__YlZ0Ehb4__";